import {
    FETCH_EXERCISE_EQUIPMENTS_FETCHING,
    FETCH_EXERCISE_EQUIPMENTS_SUCCESS,
    FETCH_EXERCISE_EQUIPMENTS_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    exerciseEquipments: [],
    exerciseEquipmentsFetching: false,
    exerciseEquipmentsSucces: false,
    exerciseEquipmentsFail: false
};

const exerciseEquipmentsFetching = (state) => ({
    ...state,
    exerciseEquipmentsFetching: true
});

const exerciseEquipmentsFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        exerciseEquipments: isSuccess ? action.exerciseEquimentsData : [],
        exerciseEquipmentsFetching: false,
        exerciseEquipmentsSucces: isSuccess,
        exerciseEquipmentsFail: !isSuccess
    };
};

export const isExerciseEquipmentsFetching = (state) => {
    return state.exerciseEquipments.exerciseEquipmentsFetching;
};

export const isExerciseEquipmentsFetchSuccess = (state) => {
    return state.exerciseEquipments.exerciseEquipmentsSucces;
};

export const isExerciseEquipmentsFetchFail = (state) => {
    return state.exerciseEquipments.exerciseEquipmentsFail;
};

export const getExerciseEquipments = (state) => {
    return state.exerciseEquipments.exerciseEquipments;
};

const handlers = {
    [FETCH_EXERCISE_EQUIPMENTS_FETCHING]: exerciseEquipmentsFetching,
    [FETCH_EXERCISE_EQUIPMENTS_SUCCESS]: exerciseEquipmentsFetchFinished(true),
    [FETCH_EXERCISE_EQUIPMENTS_FAIL]: exerciseEquipmentsFetchFinished(false)
};

export default function exerciseEquipments(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
